import {
  Divider,
  Flex,
  GridItem,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useDisclosure,
  Button,
  Center,
} from "@chakra-ui/react";
import { useState } from "react";
import Warning from "../../assets/icon/warning.svg";
import color from "../../config/color";
import ChakraPopUp from "../common/PopUp/ChakraPopUp";
import FixedText from "../common/PopUp/FixedText";
import { fetchWithToken } from "../../functions/fetch";

export default function LinkLineIdPopUp({
  isOpen,
  onClose,
  user,
  users,
  setRefetchUser,
}) {
  const [selectedId, setSelectedId] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [isSubmitting, setSubmitting] = useState();
  const {
    isOpen: isOpenConfirm,
    onOpen: onOpenConfirm,
    onClose: onCloseConfirm,
  } = useDisclosure();

  const showConfirmPopUp = () => {
    if (selectedId.length === 0) {
      setShowErrorMessage(true);
      return;
    }

    onOpenConfirm();
  };

  const confirmLinking = async () => {
    setSubmitting(true);
    const res = await fetchWithToken(
      "PUT",
      `${process.env.REACT_APP_BACKEND_HOST}/api/user/${user._id}/link/${selectedId}`,
    );
    console.log(res);

    if (res.status === 200) {
      setRefetchUser(true);
      onCloseConfirm();
      onClose();
    } else {
      console.error(res);
    }
    setSubmitting(false);
  };

  const selectedUser = users.find((user) => user._id === selectedId) ?? {};

  return (
    <>
      {
        <Modal
          isOpen={isOpenConfirm}
          onClose={onCloseConfirm}
          isCentered
          size="xl"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader bgColor={color.red} color="white" fontSize="2xl">
              確認
            </ModalHeader>
            <ModalCloseButton color="white" size="lg" />
            <ModalBody>
              <Flex direction={"column"} alignItems={"center"}>
                <Center>
                  <img src={Warning} className="w-16 h-16" />
                </Center>
                <Text fontWeight={"bold"} fontSize="xl">
                  確認綁定此會員？
                </Text>
                <Text whiteSpace={"pre-wrap"} color="blue" fontSize="lg">
                  會員編號：{user.memberNumber}
                  {"  "}身分證：{user.idNumber}
                  {"  "} 姓名：{user.name}
                </Text>
                <Text>
                  {" "}
                  注意：此動作將會以上方會員資料取代下方資料並綁定Line帳號{" "}
                </Text>
                <s style={{ color: "red" }}>
                  <Text whiteSpace={"pre-wrap"} color="red" fontSize="lg">
                    會員編號：{selectedUser.memberNumber}
                    {"  "}身分證：{selectedUser.idNumber}
                    {"  "}姓名：{selectedUser.name}
                  </Text>
                </s>
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button
                borderRadius="full"
                px={6}
                fontSize="sm"
                colorScheme="red"
                mr={3}
                type="submit"
                isLoading={isSubmitting}
                onClick={confirmLinking}
              >
                確認
              </Button>
              <Button
                borderRadius="full"
                px={6}
                fontSize="sm"
                colorScheme="gray"
                bgColor={color.gray}
                color="white"
                onClick={onCloseConfirm}
                isLoading={isSubmitting}
              >
                取消
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      }
      <ChakraPopUp
        isOpen={isOpen}
        onClose={onClose}
        title="綁定會員"
        onSubmit={showConfirmPopUp}
        size="xl"
      >
        <Flex flexDirection="column" gap={2}>
          <div className="font-chinese grid grid-cols-[repeat(2,min-content_1fr)] gap-y-2 gap-x-2 p-4 whitespace-nowrap items-center">
            <FixedText
              label="會員編號："
              text={user.memberNumber}
              textColSpan="col-span-1"
            />
            <FixedText
              label="姓名："
              text={user.name}
              textColSpan="col-span-1"
            />
            <FixedText
              label="電話號碼："
              text={user.phoneNumber}
              textColSpan="col-span-1"
            />
            <FixedText
              label="身份證字號："
              text={user.idNumber}
              textColSpan="col-span-1"
            />
            <Divider borderColor={color.orange} className="col-span-4" />
            <GridItem colSpan={4}>
              <HStack>
                <img src={Warning} className="w-8 h-8" />
                <Text fontWeight={"bold"}>
                  下方選擇之會員將會被上方取代並綁定Line帳號資料
                </Text>
              </HStack>
              <Select
                placeholder="會員編號 - 姓名 - 身份證"
                value={selectedId}
                onChange={(e) => setSelectedId(e.target.value)}
              >
                {users
                  .filter((user) => user?.hasLineId)
                  .map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.memberNumber} - {user.name} - {user.idNumber}
                    </option>
                  ))}
              </Select>
            </GridItem>
            {showErrorMessage && <Text color={color.red}>請選擇一位會員</Text>}
          </div>
        </Flex>
      </ChakraPopUp>
    </>
  );
}
